import React, { useEffect } from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { storage } from '@uhg-abyss/web/tools/storage';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { useSSO } from '@sde/widgets-core/src/redux/resources/sso';
import { LoadingOverlay as Loading } from '@uhg-abyss/web/ui/LoadingOverlay';
import { TechnicalUserButton } from '@sde/widgets-core/src/widgets/AuthenticateUser/widget/AuthenticateUser/TechnicalUserButton';

export const TechnicalUserRedirect = () => {
  const { user } = useUser.state();
  const { userSSO } = useSSO.actions();

  const handleTechnicalUserRedirect = () => {
    const productPath = storage.session.get('productPath');
    const technicalUserURL = config('TECHNICAL_USER_URL');
    const redirectURL = productPath
      ? window.location.href.replace(/#.*$/, `#${productPath}`)
      : window.location.href.replace(/#.*$/, '');
    const encodedTarget = encodeURIComponent(btoa(redirectURL));
    window.location = `${technicalUserURL}/#/redirect/${encodeURIComponent(
      encodedTarget
    )}`;
  };

  useEffect(() => {
    handleTechnicalUserRedirect();
  }, []);

  if (userSSO.saga.isLoading) {
    return <Loading isLoading loadingTitle="Loading, please wait." />;
  }

  if (user.isTechnicalUser) {
    return <TechnicalUserButton onClick={handleTechnicalUserRedirect} />;
  }
  return null;
};
